import {
  ONBOARD_EMPLOYEES_ACTION,
  ONBOARD_EMPLOYEES_VERIFY_ACTION,
  BULK_UPDATE_EMPLOYEES_ACTION,
  INVITE_EMPLOYEES_ACTION,
  INVITE_PENDING_EMPLOYEES_ACTION,
  INVITE_PENDING_EMPLOYEES_SUCCESS,
  INVITE_PENDING_EMPLOYEES_ERROR,
  UPDATE_EMPLOYEE_ACTION,
  OVERTIME_LIST_ACTION,
  GET_OVERTIME_ACTION,
  APPROVE_OVERTIME_ACTION,
  REJECT_OVERTIME_ACTION,
  LEAVE_LIST_ACTION,
  CREATE_LEAVE_ACTION, CREATE_PAYSTACK_PROFILE_ACTION,
  GET_COMPANY_PAYMENT_ACTION,
  GET_WITHDRAWAL_CATEGORIES_ACTION,
  LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_ACTION,
  UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_ACTION,
  UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_ERROR,
  EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_ACTION,
  EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_ACTION,
  LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_ACTION,
  INVITE_COMPANY_ADMIN_ACTION,
  INVITE_COMPANY_ADMIN_SUCCESS,
  INVITE_COMPANY_ADMIN_ERROR,
  CHANGE_EMPLOYEE_PERMISSION_ACTION,
  CHANGE_EMPLOYEE_PERMISSION_SUCCESS,
  CHANGE_EMPLOYEE_PERMISSION_ERROR,
} from "./types";

export const inviteCompanyAdminAction = (data) => ({
  type: INVITE_COMPANY_ADMIN_ACTION,
  payload: data
});

export const inviteCompanyAdminSuccessAction = (data) => ({
  type: INVITE_COMPANY_ADMIN_SUCCESS,
  payload: data
});

export const inviteCompanyAdminErrorAction = (error) => ({
  type: INVITE_COMPANY_ADMIN_ERROR,
  payload: error
});

export const employeeCompanyJoinRequestRejectAction = (request_id, data) => ({
  type: EMPLOYEE_COMPANY_JOIN_REQUEST_REJECT_ACTION,
  payload: data,
  request_id
})

export const updateEmployeeCompanyJoinRequestErrorAction = (error) => ({
  type: UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_ERROR,
  payload: error
})

export const employeeCompanyJoinRequestApproveAction = (request_id) => ({
  type: EMPLOYEE_COMPANY_JOIN_REQUEST_APPROVE_ACTION,
  request_id
})

export const updateEmployeeCompanyJoinRequestAction = (data, request_id) => ({
  type: UPDATE_EMPLOYEE_COMPANY_JOIN_REQUEST_ACTION,
  payload: data,
  request_id
});

export const listEmployeeCompanyJoinRequestsAction = (data) => ({
  type: LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_ACTION,
  payload: data
})

export const listEmployeeCompanyJoinRequestAuditLogsAction = (request_id, params) => ({
  type: LIST_EMPLOYEE_COMPANY_JOIN_REQUEST_AUDIT_LOGS_ACTION,
  request_id,
  payload: params
})

// Change an employee's role between ordinary / hr / admin. Client callers pass
// { is_admin, is_hr }; mutual exclusion (only one may be true) is enforced by
// the caller, and the server double-checks. user_id is the target employee's
// user id (== change-permission/<uuid:pk> on the wire).
export const changeEmployeePermissionAction = (user_id, payload) => ({
  type: CHANGE_EMPLOYEE_PERMISSION_ACTION,
  user_id,
  payload,
})

export const changeEmployeePermissionSuccessAction = (payload) => ({
  type: CHANGE_EMPLOYEE_PERMISSION_SUCCESS,
  payload,
})

export const changeEmployeePermissionErrorAction = (payload) => ({
  type: CHANGE_EMPLOYEE_PERMISSION_ERROR,
  payload,
})

export const getAdminWithdrawalCategoriesAction = (data) => ({
  type: GET_WITHDRAWAL_CATEGORIES_ACTION,
  payload: data
})

export const onBoardEmployeesAction = (data) => ({
  type: ONBOARD_EMPLOYEES_ACTION,
  payload: data,
});

export const onBoardEmployeesVerifyAction = (data) => ({
  type: ONBOARD_EMPLOYEES_VERIFY_ACTION,
  payload: data,
});

export const bulkUpdateEmployeesAction = (data) => ({
  type: BULK_UPDATE_EMPLOYEES_ACTION,
  payload: data,
});

export const inviteEmployeesAction = (data) => ({
  type: INVITE_EMPLOYEES_ACTION,
  payload: data,
});

export const invitePendingEmployeesAction = (data) => ({
  type: INVITE_PENDING_EMPLOYEES_ACTION,
  payload: data,
});

export const invitePendingEmployeesSuccessAction = (data) => ({
  type: INVITE_PENDING_EMPLOYEES_SUCCESS,
  payload: data,
});

export const invitePendingEmployeesErrorAction = (error) => ({
  type: INVITE_PENDING_EMPLOYEES_ERROR,
  payload: error,
});

export const updateEmployeeAction = (data, employee_id) => ({
  type: UPDATE_EMPLOYEE_ACTION,
  payload: data,
  employee_id,
});

export const createPayStackProfileAction = (data) => ({
  type: CREATE_PAYSTACK_PROFILE_ACTION,
  payload: data,
});

export const getOvertimeListAction = (data) => ({
  type: OVERTIME_LIST_ACTION,
  payload: data,
});

export const getOvertimeInfoAction = (overtime_id) => ({
  type: GET_OVERTIME_ACTION,
  overtime_id: overtime_id,
});

export const approveOvertimeAction = (overtime_id, data) => ({
  type: APPROVE_OVERTIME_ACTION,
  overtime_id: overtime_id,
  payload: data,
});

export const rejectOvertimeAction = (overtime_id, data) => ({
  type: REJECT_OVERTIME_ACTION,
  overtime_id: overtime_id,
  payload: data,
});

export const getLeaveListAction = (data) => ({
  type: LEAVE_LIST_ACTION,
  payload: data,
});

export const createLeaveAction = (data) => ({
  type: CREATE_LEAVE_ACTION,
  payload: data,
});


export const getCompanyPaymentsAction = (data)=> ({
  type: GET_COMPANY_PAYMENT_ACTION,
  payload: data
})